module.exports = __webpack_public_path__ + "static/media/boatyard_marker_light_blue.665bf20e.svg";